import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaFacebook, FaInstagram, FaYoutube, FaTimes } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

// Define props for MobileMenu
interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void; // Function to call to close the menu
}

// Overlay container
const MenuOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: ${props => props.isOpen ? '0' : '-100%'}; /* Slide in/out */
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.98); /* Semi-transparent white */
  z-index: 110; /* Above header */
  transition: left 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  backdrop-filter: blur(5px);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 2rem;
  color: #333;
  cursor: pointer;
`;

const MobileNavLinks = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px; /* Space below close button */
  gap: 25px;
`;

const MobileNavLink = styled(Link)`
  color: #333;
  text-decoration: none;
  font-size: 1.5rem;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  transition: color 0.2s ease;

  &:hover {
    color: #000;
  }
`;

const MobileSocialLinks = styled.div`
  margin-top: auto; /* Push to bottom */
  padding: 20px 0;
  display: flex;
  justify-content: center;
  gap: 30px;
  border-top: 1px solid #eee;
`;

const MobileSocialLink = styled.a`
  color: #555; 
  font-size: 1.5rem; 
  transition: color 0.2s ease;

  &:hover {
    color: #000;
  }
`;

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose }) => {
  return (
    <MenuOverlay isOpen={isOpen}>
      <CloseButton onClick={onClose} aria-label="Close menu">
        <FaTimes />
      </CloseButton>
      
      <MobileNavLinks>
        {/* Close menu on link click */}
        <MobileNavLink to="/" onClick={onClose}>home</MobileNavLink>
        <MobileNavLink to="/bio" onClick={onClose}>bio</MobileNavLink>
        <MobileNavLink to="/works" onClick={onClose}>works</MobileNavLink>
        <MobileNavLink to="/commissions" onClick={onClose}>commissions</MobileNavLink>
        <MobileNavLink to="/contact" onClick={onClose}>contact</MobileNavLink>
      </MobileNavLinks>

      <MobileSocialLinks>
        <MobileSocialLink href="https://www.facebook.com/rorywainwrightjohnston" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <FaFacebook />
        </MobileSocialLink>
        <MobileSocialLink href="https://www.instagram.com/rorywainwrightjohnston/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <FaInstagram />
        </MobileSocialLink>
        <MobileSocialLink href="https://x.com/rorywainwright" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
          <FaXTwitter />
        </MobileSocialLink>
        <MobileSocialLink href="https://www.youtube.com/channel/UCTQvMtOgfuzfsfKMxqkYujw" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
          <FaYoutube />
        </MobileSocialLink>
      </MobileSocialLinks>
    </MenuOverlay>
  );
};

export default MobileMenu; 